var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('the-breadcrumbs'),_c('page-content',{attrs:{"page-title":"Region bearbeiten"}},[_c('region-form',{attrs:{"loading":_vm.loading,"region":_vm.region,"form-submitted":_vm.saveRegion,"mode":"edit"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }